import { makeOneTimeScriptLoader } from "src/utils/scriptUtils";

export default makeOneTimeScriptLoader({
  src: `/appsFlyer.js`,
  nodeId: "appsFlyer-script",
});
